import type { SVGProps } from 'react';

const SvgClassG = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox='0 0 24 24' fill='none' width='1em' height='1em' focusable='false' color='currentColor' {...props}>
    <g clipPath='url(#clip0_669_26671)'>
      <path
        d='M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z'
        fill='#E25D2D'
      />
      <path
        d='M12.043 17.4001C9.04157 17.4001 6.59961 14.9776 6.59961 12.0001C6.59961 9.02261 9.04158 6.6001 12.043 6.6001C13.7597 6.6001 15.3958 7.41792 16.4194 8.78823C16.7889 9.28252 16.6843 9.98064 16.1856 10.3469C15.6878 10.7139 14.9845 10.6101 14.6145 10.115C14.0036 9.29759 13.0665 8.8284 12.043 8.8284C10.2803 8.8284 8.84581 10.2514 8.84581 12.0001C8.84581 13.7488 10.2803 15.1718 12.043 15.1718C13.0268 15.1718 13.9344 14.7365 14.5453 13.9744H12.907C12.2868 13.9744 11.7839 13.4755 11.7839 12.8602C11.7839 12.2449 12.2868 11.746 12.907 11.746H16.2763C16.6134 11.746 16.9328 11.8963 17.1463 12.1554C17.3598 12.4145 17.4442 12.7547 17.3771 13.0824C17.2163 13.8651 16.8737 14.6168 16.3864 15.2555C15.3473 16.6187 13.7643 17.4001 12.043 17.4001Z'
        fill='white'
      />
    </g>
    <defs>
      <clipPath id='clip0_669_26671'>
        <rect width={24} height={24} fill='currentColor' />
      </clipPath>
    </defs>
  </svg>
);
export default SvgClassG;
